import {
    ErrorResponse,
    RestResponse,
    RestService,
} from "@sinossi/mates-react-library"
import {
    Action,
    ActionsRequest,
    ActionTimeline, NewStepRequest,
    SearchFilter,
} from "models"
import { PaginatedResponse } from "models/commons/paginated-response"

export class ActionsServices
{
    static getDashboardActions = (request: ActionsRequest, callback: any, catchCallback: any) => {
        RestService
            .post<PaginatedResponse<Action>>(`/api/dashboard/actions`, request)
            .then(callback)
            .catch(catchCallback)
    }

    static getUrgentActions = (request: ActionsRequest, callback: any, catchCallback: any) => {
        RestService
            .post<PaginatedResponse<Action>>(`/api/actions/next`, request)
            .then(callback)
            .catch(catchCallback)
    }

    static getProgrammedActions = (request: ActionsRequest, callback: any, catchCallback: any) => {
        RestService
            .post<PaginatedResponse<Action>>(`/api/actions/future`, request)
            .then(callback)
            .catch(catchCallback)
    }

    static getNotificationActions = (request: ActionsRequest, callback: any, catchCallback: any) => {
        RestService
            .post<PaginatedResponse<Action>>(`/api/actions/notifications`, request)
            .then(callback)
            .catch(catchCallback)
    }

    static markNotificationAsRead = (notificationId: string, callback: any, catchCallback: any) => {
        RestService
            .put(`/api/actions/notifications/${notificationId}/read`, {})
            .then(callback)
            .catch(catchCallback)
    }

    static getHistory = (request: ActionsRequest, callback: any, catchCallback: any) => {
        RestService
            .post<PaginatedResponse<Action>>(`/api/actions/history`, request)
            .then(callback)
            .catch(catchCallback)
    }

    static getActionTimeline = (
        actionId: string,
        request: SearchFilter,
        callback: (response: RestResponse<PaginatedResponse<ActionTimeline>, ErrorResponse>) => void,
        catchCallback: (response: RestResponse<PaginatedResponse<ActionTimeline>, ErrorResponse>) => void,
    ) => {
        RestService
            .post<PaginatedResponse<ActionTimeline>>(`/api/action/${actionId}/timeline`, request)
            .then(callback)
            .catch(catchCallback)
    }

    static createNewAction = (request: NewStepRequest, callback: any, catchCallback: any) => {
        RestService
            .post(`/api/action`, request)
            .then(callback)
            .catch(catchCallback)
    }

    static dashboardBrandActions = (callback: any, catchCallback: any) => {
        RestService
            .get(`/api/brand/actions`)
            .then(callback)
            .catch(catchCallback)
    }

    static sendEmail = (actionId: string, callback: any, catchCallback: any) => {
        RestService
            .post(`/api/action/${actionId}/send-email`, {})
            .then(callback)
            .catch(catchCallback)
    }
}
